module.exports = __webpack_public_path__ + "static/media/tractor.33157047.svg";